export default "__VITE_ASSET__8edb2dab__"